import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

/** Current-entity target owned by the joint-use plugin workflow. */
export const CURRENT_ENTITY_TARGET: ec.models.Target =
  'Space.Organizations.JointUse'
